

export const EditorOptionsNormal = {
  selector: 'text-editor-point-description',
  menubar: false,
  branding: false,
  elementpath: false,
  placeholder: 'Write a point description...',
  toolbar_items_size: 'small',
  browser_spellcheck: true,
  plugins: [
    'link, paste, fullscreen',
  ],
  nonbreaking_force_tab: true,
  noneditable_noneditable_class: 'mceNonEditable',
  block_formats: 'Body=p;Header 1=h2;Header 2=h3;',
  toolbar: 'fullscreen | undo redo | bold underline | alignleft aligncenter | removeformat | numlist bullist | formatselect',
  skin_url: '/static/tinymce/tiny5skin/skins/ui/tiny5skin',
  media_alt_source: false,
  media_poster: false,
  media_dimensions: false,
  link_title: false,
  default_link_target: '_blank',
  target_list: false,
  contextmenu: false,
  toolbar_drawer: false,
  toolbar_mode: 'sliding',
  statusbar: false,
  height: 160,
};



// WEBPACK FOOTER //
// ./src/app/utils/EditorConfig/EditorOptionsNormal.js